<router>
{
    name: 'Bulletin Edit',
}
</router>
<template lang="pug">
v-container
    v-card(light, flat)
        BulletinEditor

</template>
<script>

import BulletinEditor from '@/components/devops/bulletineditor';

export default {
    meta: {
        role: 'devopscomms'
    },
    components: {
        BulletinEditor
    }
};
</script>

<style scoped>
</style>
